import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.athleteRoleGroups;
export const athleteRoleGroupsSelector = (state: RootState) => getState(state).data;
export const athleteRoleGroupsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const athleteRoleGroupsIsReadySelector = (state: RootState) => getState(state).isReady;
export const athleteRoleGroupsErrorSelector = (state: RootState) => getState(state).error;
